import React,{useEffect,useState} from "react";
import axios from "axios";
import { baseUrl } from "../Univ";

function Users(){

  const [users,setUsers]=useState([]);

  useEffect(()=>{
    axios.get(baseUrl+"admin-users/",{
      headers:{Authorization:`Bearer ${localStorage.getItem("access")}`}
    }).then(res=>setUsers(res.data));
  },[]);

  const toggleSeller = async(id)=>{
    await axios.post(
      baseUrl+"toggle-seller/",
      {id},
      {headers:{Authorization:`Bearer ${localStorage.getItem("access")}`}}
    );
    window.location.reload();
  };

  return(
    <div className="container mt-4">
      <h3>Users</h3>

      {users.map(u=>(
        <div key={u.id} className="border p-2 mb-2">
          {u.username} - {u.is_seller ? "Seller":"Customer"}
          <button
            className="btn btn-sm btn-primary ms-3"
            onClick={()=>toggleSeller(u.id)}
          >
            Toggle Seller
          </button>
        </div>
      ))}

    </div>
  );
}

export default Users;
